export default async function ({ store }) {
  const unidadeInformation = store.getters['unidade/unidadeInformation']
  let url = window.location.hostname

  url = url.replace(/^www\./, '')

  try {
    if (!unidadeInformation) {
      await store.dispatch('unidade/fetchUnidade', { url })
    }
  } catch (error) {
    console.error(error)
  }
}
